import { useRouter } from 'next/dist/client/router'
import { VFC } from 'react'
import {
  PROFILE_NEEDS,
  PROFILE_NOTIFICATION,
  PROFILE_PASSWORD,
  PROFILE_PERSONA,
  PROFILE_SCHEDULE,
  PROFILE_SOLUTIONS,
  PROFILE_USER,
} from 'src/assets/images'
import { Link } from 'src/elements/Link'
import { orange, white } from 'src/styles/colors'
import { fontWeightSemiBold } from 'src/styles/font'
import {
  EDIT_COMPANY,
  EDIT_NEEDS,
  EDIT_PASSWORD,
  EDIT_PERSONA,
  EDIT_PROFILE,
  EDIT_SCHEDULE_URL,
  EDIT_SETTLER,
  EDIT_SOLUTIONS,
  NOTICE_CONFIGURATION,
} from 'src/utils/routes'
import styled, { css } from 'styled-components'

type ProfileSideMenu = {
  isActiveScheduleUrl: boolean
  isSalesDemoPlan: boolean
}
export const ProfileSideMenu: VFC<ProfileSideMenu> = ({
  isActiveScheduleUrl,
  isSalesDemoPlan,
}) => {
  const { asPath } = useRouter()
  const profilePaths = [EDIT_PROFILE, EDIT_COMPANY, EDIT_SETTLER]

  return (
    <SideMenuList>
      <h2>設定情報の編集</h2>
      <SideMenuItem
        label="プロフィールの編集"
        href={EDIT_PROFILE}
        isCurrent={profilePaths.includes(asPath)}
        src={PROFILE_USER}
        height={20}
      />
      <SideMenuItem
        label="ニーズの編集"
        href={EDIT_NEEDS}
        isCurrent={asPath.includes(EDIT_NEEDS)}
        src={PROFILE_NEEDS}
        width={20}
      />
      <SideMenuItem
        label="ソリューションの編集"
        href={EDIT_SOLUTIONS}
        isCurrent={asPath.includes(EDIT_SOLUTIONS)}
        src={PROFILE_SOLUTIONS}
        width={20}
      />
      <SideMenuItem
        label="ペルソナ登録"
        href={EDIT_PERSONA}
        isCurrent={asPath.includes(EDIT_PERSONA)}
        src={PROFILE_PERSONA}
        width={20}
      />
      {!isSalesDemoPlan && (
        <SideMenuItem
          label="パスワードの変更"
          href={EDIT_PASSWORD}
          isCurrent={asPath.includes(EDIT_PASSWORD)}
          src={PROFILE_PASSWORD}
          width={20}
        />
      )}
      {/* Temporarily hidden - story list editing feature
      <SideMenuItem
        label="ストーリー記事の編集"
        href={EDIT_STORYLIST}
        isCurrent={asPath.includes(EDIT_STORYLIST)}
        src={PROFILE_STORY}
        height={20}
      />
      */}
      {isActiveScheduleUrl && (
        <SideMenuItem
          label="日程調整URL登録"
          href={EDIT_SCHEDULE_URL}
          isCurrent={asPath.includes(EDIT_SCHEDULE_URL)}
          src={PROFILE_SCHEDULE}
          width={18}
        />
      )}
      <SideMenuItem
        label="通知設定"
        href={NOTICE_CONFIGURATION}
        isCurrent={asPath.includes(NOTICE_CONFIGURATION)}
        src={PROFILE_NOTIFICATION}
        height={20}
      />
    </SideMenuList>
  )
}

type SideMenuItemProps = {
  label: string
  href: string
  isCurrent: boolean
  src: string
  height?: number
  width?: number
}
const SideMenuItem: VFC<SideMenuItemProps> = ({
  label,
  href,
  isCurrent,
  src,
  height = 'auto',
  width = 'auto',
}) => {
  return (
    <Link href={href}>
      <List $isCurrent={isCurrent}>
        <img src={src} alt="" height={height} width={width} />
        <label>{label}</label>
      </List>
    </Link>
  )
}

const SideMenuList = styled.ul`
  top: 100px;
  width: 100%;
  height: auto;
  min-height: 260px;
  padding-top: 40px;
  padding-left: 32px;
  padding-right: 32px;
  font-weight: ${fontWeightSemiBold};
  letter-spacing: 0.05em;

  h2 {
    font-size: 18px;
    font-weight: 700;
    margin-bottom: 20px;
  }
`

const List = styled.li<{ $isCurrent: boolean }>`
  transition: color 0.1s;
  ${({ $isCurrent }) =>
    $isCurrent
      ? css`
          color: ${white};
          background: linear-gradient(114.4deg, #fba14e -10.4%, #e53019 87.47%);

          img {
            filter: brightness(0) invert(1);
          }
        `
      : css`
          :hover {
            color: ${orange};

            img {
              filter: invert(44%) sepia(97%) saturate(2345%) hue-rotate(1deg)
                brightness(103%) contrast(104%);
            }
          }
        `}

  width: 100%;
  height: 52px;
  font-size: 14px;
  line-height: 20px;
  padding: 16px 15px;
  margin-bottom: 10px;
  border-radius: 10px;

  :not(:last-child) {
    margin-bottom: 8px;
  }

  img {
    vertical-align: middle;
  }

  label {
    margin-left: 15px;
    cursor: pointer;
  }
`
